export default {
    box: {
        display: 'flex',
        alignItems: 'center',
    },
    value: {
        marginLeft: '10px',
    },
};
